import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ivclass from '../../Modules/IVClass';
function TitleH2({ heading, theme, spanClass, headingClass, overwriteClass = false, }) {
    return (_jsxs("h2", { className: overwriteClass
            ? headingClass
            : ivclass(theme === 'dark'
                ? 'iv-text-grey-0'
                : 'iv-text-grey-100 dark:iv-text-grey-0', 'iv-text-heading-4xl lg:iv-text-heading-2xl md:iv-text-heading-2xl sm:iv-text-heading-2xs', 'iv-m-heading-3xl lg:iv-m-heading-2xl md:iv-m-heading-2xl sm:iv-m-heading-2xs', 'iv-font-extrabold iv-text-center iv-w-full iv-h-full', headingClass), children: [heading.plainHeading, _jsx("span", { className: ivclass('iv-h-full', 'iv-title-gradient', theme === 'dark' && 'dark:iv-gradient-deep-blue-blue-turquoise', spanClass ? spanClass : 'iv-block'), children: heading.highlightedHeading })] }));
}
export default TitleH2;
